import { Download } from "lucide-react";
import React from "react";

import { downloadCsv } from "./csv";

interface ExportButtonProps {
  filename: string;
  getCsv: () => string;
  disabled?: boolean;
  label?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  filename,
  getCsv,
  disabled,
  label = "Export CSV",
}) => {
  const [hover, setHover] = React.useState(false);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        if (disabled) return;

        downloadCsv(filename, getCsv());
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 6,
        border: "1px solid rgba(15, 23, 42, 0.12)",
        background: hover && !disabled ? "rgba(15, 23, 42, 0.04)" : "#fff",
        color: disabled ? "#9CA3AF" : "#374151",
        fontSize: 12,
        fontWeight: 600,
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background 120ms ease",
      }}
    >
      <Download size={12} />
      {label}
    </button>
  );
};
